require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-people-partners-products-seattle-orgs-win-big-with-our-expanded-employer-services.json") })
        }
      }, "path---blog-people-partners-products-seattle-orgs-win-big-with-our-expanded-employer-services");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-people-partners-products-seattle-orgs-win-big-with-our-expanded-employer-services!./.cache/json/blog-people-partners-products-seattle-orgs-win-big-with-our-expanded-employer-services.json
// module id = 1016
// module chunks = 231608221292675